import ApiDocsOverView from './ApiDocsOverView';
import './ApiDocsView.scss';

export default ApiDocsOverView;
